import { createContext, useMemo, useState } from "react";
import ConfirmDialog from "../common/Modal/Confirm.tsx";
import Modal from "../common/Modal/Modal.tsx";
import {
  ConfirmDialogProps,
  CustomModalProps,
  OpenModalData,
} from "../lib/types/Overlays.ts";
import { ModalType } from "../lib/constants/Overlays.ts";

export const GlobalOverlayContext = createContext(null);

type ModalData = false | OpenModalData;

const OverlayProvider = ({ children }) => {
  const [modalData, setModalData] = useState<ModalData>(false);

  const openModal = (data: OpenModalData) => setModalData(data);
  const closeModal = () => setModalData(false);

  const modal = useMemo(() => {
    if (modalData == false) return null;
    switch (modalData?.type) {
      case ModalType.CONFIRM:
        return (
          <ConfirmDialog
            {...(modalData.props as ConfirmDialogProps)}
            isOpen={true}
            onClose={closeModal}
          />
        );
      default:
        return (
          <Modal
            {...(modalData.props as CustomModalProps)}
            isOpen={true}
            onClose={closeModal}
          />
        );
    }
  }, [modalData]);

  return (
    <GlobalOverlayContext.Provider value={{ openModal, closeModal }}>
      <>
        {children}
        {modal}
      </>
    </GlobalOverlayContext.Provider>
  );
};

export default OverlayProvider;
